import React, { useState, useRef } from "react";
import {
  Card,
  Grid,
  Typography,
  Divider,
  TextField,
  Radio,
  RadioGroup,
  Tooltip,
  Button,
  makeStyles,
  FormControlLabel,
  FormHelperText,
} from "@material-ui/core";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import FormControl from "@mui/material/FormControl";
import ListItem from "@mui/material/ListItem";
import styled from "styled-components";
import Switch from "@mui/material/Switch";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import InputAdornment from "@mui/material/InputAdornment";
import EditIcon from "@mui/icons-material/EditOutlined";
import DoneIcon from "@mui/icons-material/Done";
import TrashIcon from "@mui/icons-material/DeleteOutline";

import AddIcon from "@mui/icons-material/Add";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import draftToHtml from "draftjs-to-html";
import ReactHtmlParser from "react-html-parser";
import TextEditor from "./TextEditor.js";
import AlertDialog from "../../../components/AlertDialog.js";
import infoImg from "../../../assets/icons/info.png";

var findAnd = require("find-and");

const StyledTooltip = styled(props => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -35px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 500;
  }
`;
const useStyles = makeStyles(theme => ({
  outlinedButtonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#0D47A1",
    height: "34px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:active": {
      backgroundColor: "#0D47A1",
    },
    "&:hover": {
      backgroundColor: "#0D47A1",
    },
  },
  subDialog: {
    "& .MuiDialogContent-root": {
      padding: 0,
    },
    "& .MuiPaper-root": {
      width: "100%",
      maxWidth: "1100px",
      height: "600px",
    },
  },
  textFieldStyle: {
    marginBottom: 5,
    marginTop: 20,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 4,
      fontSize: 16,
      backgroundColor: "#fff",
    },
  },
  textFieldOnFormStyle: {
    marginBottom: 5,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
      fontSize: 16,
      backgroundColor: "#fff",
    },
  },

  switch: {
    "& .MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track": {
      backgroundColor: "#0D47A1",
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      color: "#0D47A1",
    },
  },
  inputWithButton: {
    position: "relative",
    "& TextField": {
      width: "70%",
      height: 25,
      paddingRight: 60,
    },
    "& button": {
      position: "absolute",
      right: 8,
      top: 28,
    },
  },
  addIconStyle: {
    "&:hover": {
      backgroundColor: "#f6fafe",
    },
  },
  listItem: {
    backgroundColor: "#f6fafe",
    paddingLeft: 5,
    borderRadius: 8,
    marginBottom: 10,
  },
  editTextFieldStyle: {
    width: "85% !important",
    "& .MuiInput-root": {
      fontSize: 14,
      fontWeight: 400,
    },
  },
  actionIcon: {
    color: "#0000008a !important",
  },
  errorStyle: {
    marginTop: 0,
    fontSize: 14, //16,
    fontFamily: "Arial",
  },
}));

export default function AddRadioButtonToFormDialog({ closeDialog, handleDone }) {
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const [infoIcon, setInfoIcon] = useState(false);
  const [manAnswer, setManAnswer] = useState(false);
  const [queText, setQueText] = useState(false);
  const [queRaw, setQueRaw] = useState(false);
  const [capText, setCapText] = useState(false);
  const [capRaw, setCapRaw] = useState(false);
  const [infoTxt, setInfoTxt] = useState("");
  const [alertMsg, setAlertMsg] = useState([]);
  const [optionText, setOptionText] = useState("");
  const [options, setOptions] = useState([]);
  const [editedTitle, setEditedTitle] = useState("");

  const editorRef = useRef(null);
  const [checkError, setCheckError] = useState(false);

  const handleClose = () => {
    setOpen(false);
    closeDialog && closeDialog();
  };

  const toggleEditFlag = opt => {
    var allowToggle = false;
    var title = opt.title;
    if (opt.editable) {
      if (editedTitle.trim() != "") {
        let index = options.find(item => item.title === editedTitle);
        if (index && index.index !== opt.index) {
          setAlertMsg({
            title: "Option Label Validation",
            msg: "Option label already exists. Please input a different label.",
          });
          document.getElementById(opt.title).focus();
        } else {
          title = editedTitle;
          setEditedTitle("");
          allowToggle = true;
          document.getElementById("newOptionTextField").focus();
        }
      }
    } else {
      setEditedTitle(title);
      allowToggle = true;
    }
    if (allowToggle) {
      const chgOptProps = findAnd.changeProps(
        options,
        { title: opt.title },
        {
          editable: !opt.editable,
          title: title,
        }
      );
      setOptions(chgOptProps);
    }
  };
  const cancleEditOption = opt => {
    var oldTitle = opt.title;
    const chgOptProps = findAnd.changeProps(
      options,
      { title: opt.title },
      {
        editable: false,
        title: oldTitle,
      }
    );
    setEditedTitle("");
    setOptions(chgOptProps);
    document.getElementById("newOptionTextField").focus();
  };

  const handleDeleteOption = opt => {
    let foundItem = options.find(item => {
      return item.title === opt.title;
    });
    if (foundItem) {
      let filteredData = options.filter(item => item.title !== foundItem.title);
      if (filteredData) setOptions(filteredData);
    }
    document.getElementById("newOptionTextField").focus();
  };

  const handleUpdateOpt = (e, index) => {
    setEditedTitle(e.target.value);
  };

  const addNewOption = () => {
    if (optionText.trim() != "") {
      let index = options.find(item => item.title === optionText);
      if (index)
        setAlertMsg({
          title: "Option Label Validation",
          msg: "Option label already exists. Please input a different label.",
        });
      else {
        setOptions([
          ...options,
          { index: options.length, title: optionText, editable: false },
        ]);
        setOptionText("");
        document.getElementById("newOptionTextField").focus();
      }
    }
  };

  const handleKeyDown = event => {
    if (event.key === "Enter") {
      addNewOption();
    }
  };
  const handleEditKeyDown = (event, opt) => {
    if (event.key === "Enter") {
      toggleEditFlag(opt);
    }
  };

  const switchInfoTextField = () => {
    setInfoIcon(!infoIcon);
    if (infoIcon) {
      setInfoTxt("");
      document.getElementById("infoTooltipTextField").disabled = true;
    } else {
      document.getElementById("infoTooltipTextField").disabled = false;
      document.getElementById("infoTooltipTextField").focus();
    }
  };

  const handleChangeTextEditor = (txt, type) => {
    let contentHTML = draftToHtml(txt);
    contentHTML = contentHTML.replace(/<p>/, "");

    contentHTML = contentHTML.replace(
      /<a[^>]*href="([^"]+)"[^>]*>(.*?)<\/a>/gi,
      (match, href, text) => {
        // Remove leading protocols
        href = href.replace(/^(https?:\/\/)+/, "");

        // Prepend https://
        href = `https://${href}`;

        return `<a href="${href}" target="_blank">${text}</a>`;
      }
    );
    
    const convertedTxt = ReactHtmlParser(contentHTML);

    if (type === "question") {
      setQueText(convertedTxt);
      setQueRaw(txt);
    }
    if (type === "caption") {
      setCapText(convertedTxt);
      setCapRaw(txt);
    }
  };

  const validateFields = () => {
    setCheckError(true);
    if (queRaw.blocks[0].text.trim() === "") {
      editorRef.current.focus();
      return false;
    }
    if (infoIcon && infoTxt.trim() === "") {
      return false;
    }
    return true;
  };

  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth="xl"
      //  onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className={classes.subDialog}
    >
      <DialogTitle sx={{ p: 0 }} id="alert-dialog-title">
        <Box
          style={{
            display: "flex",
            flexDirection: "row",
          }}
        >
          <Grid container>
            <Grid
              item
              lg={4}
              xl={4}
              md={4}
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                paddingBottom: 15,
              }}
            >
              <Box style={{ width: 100 }}>
                <IconButton
                  aria-label="close"
                  sx={{
                    position: "absolute",
                    left: 8,
                    top: 8,
                    align: "right",
                    color: theme => theme.palette.grey[500],
                  }}
                  onClick={e => {
                    if (
                      queRaw.blocks[0].text ||
                      capRaw.blocks[0].text ||
                      infoTxt ||
                      options.length > 0
                    )
                      setAlertMsg({
                        title: "Exit",
                        type: "saveConfirmation",
                        msg: "Are you sure you want to exit without saving your work?",
                      });
                    else handleClose();
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Box>
              <Box pt={2} style={{ width: 350 }}>
                <Typography
                  variant="h1"
                  style={{
                    fontSize: 20,
                    display: "flex",
                    //    flexDirection: "end",
                    alignItems: "center",
                  }}
                >
                  Object: Radio Button
                </Typography>
              </Box>
            </Grid>
            <Grid item lg={8} xl={8} md={8} style={{ backgroundColor: "#E3F2FD" }}></Grid>
          </Grid>
        </Box>
      </DialogTitle>
      <DialogContent
        style={{
          alignItems: "center",
          display: "flex",
          justifyContent: "center",
          overflow: "hidden",
        }}
      >
        <Grid container>
          <Grid item lg={4} xl={4} md={4}>
            <Card style={{ maxHeight: "550px", overflowY: "scroll" }}>
              <Box mb={1} mt={5}>
                <Divider />
                <Box mt={2} ml={2}>
                  <Typography variant="h3">Question*</Typography>
                </Box>
                <Box mt={2} ml={2} mb={2} mr={2}>
                  <TextEditor
                    type="question"
                    handleChangeText={(txt, type) => handleChangeTextEditor(txt, type)}
                    editorRef={editorRef}
                  />
                  {checkError && queRaw && queRaw.blocks[0].text.trim() === "" && (
                    <FormHelperText className={classes.errorStyle} error>
                      Question field cannot be blank.
                    </FormHelperText>
                  )}
                </Box>
                <Divider />
                <Box mt={2} ml={2}>
                  <Typography variant="h3">Caption</Typography>
                </Box>
                <Box mt={2} ml={2} mb={2} mr={2}>
                  <TextEditor
                    type="caption"
                    handleChangeText={(txt, type) => handleChangeTextEditor(txt, type)}
                  />
                </Box>
                <Divider />
                <Box mt={2} ml={2}>
                  <Typography variant="h3">Option</Typography>
                </Box>
                <Box mt={2} ml={2} mb={2} mr={2}>
                  <Box sx={{ minWidth: 120 }}>
                    <FormControl fullWidth>
                      <Box mt={1}>
                        <TextField
                          id="newOptionTextField"
                          variant="outlined"
                          placeholder="Enter Option Label"
                          className={classes.textFieldStyle}
                          value={optionText}
                          onChange={e => setOptionText(e.target.value)}
                          fullWidth
                          onKeyDown={handleKeyDown}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <StyledTooltip title="Add">
                                  <IconButton
                                    aria-label="add"
                                    className={classes.addIconStyle}
                                    disabled={!optionText}
                                    onClick={() => {
                                      addNewOption();
                                    }}
                                  >
                                    <AddIcon />
                                  </IconButton>
                                </StyledTooltip>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Box>
                      <Box mt={1}>
                        <Card
                          variant="outlined"
                          style={{ maxHeight: "177px", overflowY: "scroll" }}
                        >
                          <List>
                            <Box
                              pl={1}
                              pr={1}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              {options.map((option, index) => (
                                <ListItem
                                  className={classes.listItem}
                                  secondaryAction={
                                    <>
                                      {!option.editable ? (
                                        <>
                                          <StyledTooltip title="Edit">
                                            <IconButton
                                              onClick={() => {
                                                toggleEditFlag(option);
                                              }}
                                              className={classes.actionIcon}
                                              disabled={editedTitle !== "" ? true : false}
                                            >
                                              <EditIcon />
                                            </IconButton>
                                          </StyledTooltip>
                                          <StyledTooltip title="Delete">
                                            <IconButton
                                              edge="end"
                                              onClick={() => handleDeleteOption(option)}
                                              className={classes.actionIcon}
                                              disabled={editedTitle !== "" ? true : false}
                                            >
                                              <TrashIcon />
                                            </IconButton>
                                          </StyledTooltip>
                                        </>
                                      ) : (
                                        <>
                                          <StyledTooltip title="Save">
                                            <IconButton
                                              onClick={() => {
                                                toggleEditFlag(option);
                                              }}
                                            >
                                              <DoneIcon />
                                            </IconButton>
                                          </StyledTooltip>
                                          <StyledTooltip title="Cancel">
                                            <IconButton
                                              edge="end"
                                              onClick={() => cancleEditOption(option)}
                                            >
                                              <CloseIcon />
                                            </IconButton>
                                          </StyledTooltip>
                                        </>
                                      )}
                                    </>
                                  }
                                >
                                  {!option.editable ? (
                                    <Typography
                                      style={{
                                        fontSize: 14,
                                        fontWeight: 400,
                                        width: 190,
                                        wordWrap: "break-word",
                                      }}
                                    >
                                      {option.title}
                                    </Typography>
                                  ) : (
                                    <TextField
                                      InputProps={{
                                        disableUnderline: true,
                                      }}
                                      id={option.title}
                                      autoFocus
                                      onKeyDown={event =>
                                        handleEditKeyDown(event, option)
                                      }
                                      variant="standard"
                                      defaultValue={option.title}
                                      className={classes.editTextFieldStyle}
                                      fullWidth
                                      onChange={event => handleUpdateOpt(event, index)}
                                    />
                                  )}
                                </ListItem>
                              ))}
                            </Box>
                          </List>
                        </Card>
                      </Box>
                    </FormControl>
                  </Box>
                </Box>
                <Divider />
                <Box
                  mt={2}
                  ml={2}
                  mr={1}
                  mb={2}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography variant="h3">Answer is Mandatory</Typography>
                  <Switch
                    checked={manAnswer}
                    onChange={() => setManAnswer(!manAnswer)}
                    className={classes.switch}
                  />
                </Box>
                <Divider />
                <Box
                  mt={2}
                  ml={2}
                  mr={1}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography variant="h3">Enable Information Icon</Typography>
                  <Switch
                    checked={infoIcon}
                    onChange={() => {
                      switchInfoTextField();
                    }}
                    className={classes.switch}
                  />
                </Box>
                <Box ml={2} mb={2} mr={2}>
                  <TextField
                    id="infoTooltipTextField"
                    variant="outlined"
                    placeholder="Type tooltip label ..."
                    className={classes.textFieldStyle}
                    value={infoTxt}
                    disabled={!infoIcon}
                    onChange={e => setInfoTxt(e.target.value)}
                    fullWidth
                    helperText={
                      checkError &&
                      infoIcon &&
                      infoTxt.trim() === "" &&
                      "This field cannot be blank."
                    }
                    error={checkError && infoIcon && infoTxt.trim() === ""}
                  />
                </Box>
                <Box
                  mt={5}
                  ml={2}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.buttonStyle}
                    style={{ marginRight: 2 }}
                    onClick={() => {
                      if (!validateFields()) return;
                      if (
                        queRaw.blocks[0].text ||
                        capRaw.blocks[0].text ||
                        infoTxt ||
                        options.length > 0
                      )
                        handleDone(
                          "Radio Button",
                          "done",
                          infoIcon,
                          manAnswer,
                          queText,
                          queRaw,
                          capText,
                          capRaw,
                          null,
                          infoTxt,
                          null,
                          options
                        );
                      else {
                        setAlertMsg({
                          title: "Alert",
                          msg: "Nothing is added.",
                        });
                      }
                    }}
                  >
                    Save
                  </Button>
                  <Button
                    variant="text"
                    color="primary"
                    className={classes.outlinedButtonStyle}
                    onClick={handleClose}
                  >
                    Cancel
                  </Button>
                </Box>
              </Box>
            </Card>
          </Grid>
          <Grid item lg={8} md={8} xl={8}>
            <Card style={{ backgroundColor: "#E3F2FD" }}>
              <Box
                mt={6}
                mb={1.5}
                ml={10}
                mr={10}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <Box
                  style={{
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <Box style={{ display: "flex", flexDirection: "row" }}>
                    {infoIcon && infoTxt ? (
                      <StyledTooltip title={infoTxt}>
                        <img
                          style={{
                            paddingBottom: 3,
                            paddingRight: 5,
                            height: 24,
                          }}
                          src={infoImg}
                        />
                      </StyledTooltip>
                    ) : infoIcon && !infoTxt ? (
                      <img
                        style={{
                          paddingBottom: 3,
                          paddingRight: 5,
                          height: 24,
                        }}
                        src={infoImg}
                      />
                    ) : (
                      ""
                    )}
                  </Box>
                  <Typography
                    variant="h3"
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        wordBreak: "break-word",
                      }}
                    >
                      {queText ? queText : ""}
                    </div>
                  </Typography>
                </Box>

                <Typography
                  variant="h3"
                  style={{
                    fontSize: 14,
                    display: "flex",
                    alignItems: "center",
                    paddingLeft: 3,
                    paddingBottom: 5,
                    paddingTop: 20,
                  }}
                >
                  <div
                    style={{
                      wordBreak: "break-word",
                    }}
                  >
                    {capText ? capText : ""}
                  </div>
                </Typography>

                <Box pb={0.25} style={{ display: "flex", flexDirection: "row" }}>
                  {manAnswer && (
                    <>
                      <Typography
                        variant="h3"
                        style={{
                          fontSize: 14,
                          display: "flex",
                          alignItems: "center",
                          paddingLeft: 5,
                        }}
                      >
                        Required
                      </Typography>
                      <StyledTooltip title="required field">
                        <Typography
                          variant="h3"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            color: "#E53935",
                            paddingLeft: 5,
                            paddingRight: 5,
                          }}
                        >
                          *
                        </Typography>
                      </StyledTooltip>
                    </>
                  )}
                </Box>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue="female"
                  name="radio-buttons-group"
                >
                  {options.map((option, index) => (
                    <FormControlLabel
                      value={option.title}
                      control={<Radio style={{ fontSize: 16 }} />}
                      label={
                        <Typography
                          variant="h3"
                          style={{
                            display: "flex",
                            fontSize: 16,
                            alignItems: "center",
                            paddingLeft: 5,
                            paddingRight: 5,
                          }}
                        >
                          {option.title}
                        </Typography>
                      }
                      style={{ fontSize: "16px !important" }}
                    />
                  ))}
                </RadioGroup>
              </Box>
            </Card>
          </Grid>
          {alertMsg.msg && (
            <AlertDialog
              title={alertMsg.title}
              type={alertMsg.type}
              contentMsg={alertMsg.msg}
              closeDialog={() => setAlertMsg([])}
              cancelSaveAction={() => {
                setAlertMsg([]);
                handleClose();
              }}
            />
          )}
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
